import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { ChevronUpDownIcon, StarIcon } from "@heroicons/react/20/solid";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { TOption, TSelectorProps } from "./dropMenu.types";
import clsx from "clsx";
const Selector = ({
  placeholder = "Select any option",
  label,
  value,
  onChange,
  options,
  error,
  disabled = false,
  className = "",
  optionsClassName = "",
  accessorKey = "name",
  isRequired = true,
  textEllipsis = 100,
  anchorPosition = "bottom",
  leftAsterisk = false,
}: TSelectorProps) => {
  // Function to handle change in select option
  function handleChange(option: TOption) {
    onChange(option);
  }
  return (
    <div className="relative w-full">
      <Listbox
        onChange={handleChange}
        value={value ?? {}}
        disabled={disabled}
        by="id"
      >
        {label && (
          <label
            className={`text-xs flex items-center gap-1 text-left text-body font-semibold pl-1 ${leftAsterisk ? "relative " : ""}`}
          >
            {label}
            {isRequired && (
              <StarIcon
                className={`size-2 text-error -translate-y-1 ${leftAsterisk ? "absolute top-1 -left-2" : ""}`}
              />
            )}
          </label>
        )}

        <ListboxButton
          className={clsx(
            "min-w-full h-10 border-2 rounded-lg outline-none text-sm flex items-center justify-between text-body font-semibold px-2",
            error ? "border-primary/50" : "border-extraLightGray",
            "disabled:cursor-not-allowed disabled:opacity-70 disabled:bg-extraLightGray/30",
            "focus:ring-primary focus:border-primary/50",
            className
          )}
        >
          <span
            className={clsx(
              "text-sm",
              value?.[accessorKey]
                ? "text-subHeading font-semibold"
                : "text-darkGray/80 font-medium"
            )}
          >
            {stringUtility.addEllipsisAtEnd(
              value?.[accessorKey] || placeholder,
              textEllipsis
            )}
          </span>
          {!disabled && options?.length > 0 ? (
            <span>
              <ChevronUpDownIcon
                data-error={error}
                className="h-5 w-5 text-gray data-[error=true]:text-error"
                aria-hidden="true"
              />
            </span>
          ) : (
            ""
          )}
        </ListboxButton>
        {error?.message && (
          <p className="text-xs text-error font-medium pl-2 mt-0.5">
            {error?.message}
          </p>
        )}

        <ListboxOptions
          anchor={anchorPosition}
          transition
          className={clsx(
            "w-[var(--button-width)] [--anchor-gap:4px] shadow-md border bg-white border-extraLightGray rounded-md max-h-48 overflow-y-auto outline-none z-50",
            optionsClassName
          )}
        >
          {options?.length > 0 ? (
            options?.map((option) => (
              <ListboxOption
                key={option?.id}
                value={option}
                className="px-4 py-2 text-sm font-semibold transition-colors cursor-pointer select-none   outline-none data-[selected]:text-white data-[selected]:bg-primary data-[focus]:text-body data-[focus]:bg-primary/20"
              >
                {option?.[accessorKey]}
              </ListboxOption>
            ))
          ) : (
            <div className="flex text-sm font-semibold text-heading px-4 py-2">
              No Data found !
            </div>
          )}
        </ListboxOptions>
      </Listbox>
    </div>
  );
};

export default Selector;
